import { Card, CardContent } from "./ui/card";
import { 
  Waves, 
  Zap, 
  Wifi, 
  Car, 
  Coffee, 
  Gamepad2, 
  Shirt, 
  Heart,
  Bath,
  PawPrint
} from "lucide-react";

const amenities = [
  {
    icon: Zap,
    title: "Full Hookup Sites",
    description: "50 amp electric, water & sewer connections for all RV sites"
  },
  {
    icon: Wifi,
    title: "Free WiFi",
    description: "Stay connected while enjoying your getaway (streaming not available)"
  },
  {
    icon: Car,
    title: "Pull-through & Back-in Spaces",
    description: "Efficient and larger spaces to accommodate all RV sizes"
  },
  {
    icon: Waves,
    title: "Swimming Pool & Hot Tub",
    description: "Relax and unwind in our sparkling pool or soothing hot tub"
  },
  {
    icon: Gamepad2,
    title: "Recreation Activities",
    description: "Shuffleboard, horseshoe pits, ladderball, and corn hole games"
  },
  {
    icon: Shirt,
    title: "Onsite Laundromat",
    description: "Coin-op washing machines and dryers for tenant convenience"
  },
  {
    icon: Coffee,
    title: "Clubhouse with Kitchen",
    description: "Social hub for games, events, potlucks and meeting new friends"
  },
  {
    icon: PawPrint,
    title: "Pet-Friendly Areas",
    description: "Welcome small dogs under 25 lbs with designated dog run area"
  },
  {
    icon: Bath,
    title: "Pristine Restrooms & Showers",
    description: "24-hour access to clean, well-maintained facilities"
  },
  {
    icon: Heart,
    title: "55+ Community",
    description: "Peaceful retreat designed for mature adults seeking relaxation"
  }
];

export function AmenitiesSection() {
  return (
    <section id="amenities" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4">
            On-Site Amenities
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            We've designed the Fun 'n Sun Mobile Home and RV Park with your comfort, 
            convenience, and lifestyle in mind.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {amenities.map((amenity, index) => (
            <Card key={index} className="hover:shadow-lg transition-shadow">
              <CardContent className="p-6">
                <div className="flex items-start gap-4">
                  <div className="bg-primary/10 p-3 rounded-lg flex-shrink-0">
                    <amenity.icon className="h-6 w-6 text-primary" />
                  </div>
                  <div>
                    <h3 className="font-semibold mb-2">{amenity.title}</h3>
                    <p className="text-muted-foreground text-sm leading-relaxed">
                      {amenity.description}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="bg-sky-blue/10 border border-sky-blue/20 rounded-lg p-6 max-w-2xl mx-auto">
            <h3 className="font-semibold mb-2 text-sky-blue">Pool & Laundry Hours</h3>
            <div className="text-sm space-y-1">
              <p><strong>In Season (Oct-May):</strong> 7:00 AM - 9:00 PM</p>
              <p><strong>Off Season (Jun-Sep):</strong> 9:00 AM - 9:00 PM</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}